(function(){
    'use strict';
    angular.module('Services').factory('RoutePlanningService', RoutePlanningService);
    RoutePlanningService.$inject = [];

    function RoutePlanningService() {
        return {
            // todo: add implementation code here...
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/RoutePlanningService.js